// extracted by mini-css-extract-plugin
module.exports = {"updateTableSection":"product-update-table-module--updateTableSection--3dJPE"};